import { useEffect, useState } from 'react';

/** Reactive `window.matchMedia`. Used to switch the sidebar between an inline
 *  column (desktop) and an overlay sheet (mobile). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mq.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

/** Below this width the sidebar overlays the content instead of sitting beside it. */
export const MOBILE_QUERY = '(max-width: 1023px)';
